import { action, observable, makeObservable } from 'mobx';

class WinnersStore {
  winnersData = [];

  constructor() {
    makeObservable(this, {
      winnersData: observable.deep,
      setWinnersData: action.bound,
      resetWinnersData: action.bound,
    });
  }

  setWinnersData(data) {
    this.winnersData = [...this.winnersData, ...data];
  }

  resetWinnersData(data) {
    this.winnersData = data;
  }
}

export const winnersStore = new WinnersStore();
